import React from 'react';
import t from 'prop-types';
import './Section.scss'; 

class Section extends React.Component {
  static propTypes = {
    children: t.arrayOf(t.element).isRequired,
  };

  render() {
    const { background, ...props } = this.props;
    return (
      <section {...props} style={{background: background}}>
        <div className="container">{this.props.children}</div>
      </section>
    );
  }
}

export default Section;
